import React, { useEffect, useState } from 'react';
import './Imgslider.css'; // Make sure to create and import this CSS file

function Imgslider() {
    const [index, setIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const slider = [
        { src: "https://www.hathway.com/broadband-images/hero-webslider-1.jpg",text: 'Kavi Broadband - Choose This, Change Your Life Experience', },
        { src: "https://images.jdmagicbox.com/comp/gandhinagar-gujarat/r6/9999pxx79.xx79.160713215154.x8r6/catalogue/redline-network-and-computer-solutions-kalol-ng-gandhinagar-gujarat-broadband-internet-service-providers-3tdiasos0q.jpg" , text:''},
        { src: "https://images.jdmagicbox.com/comp/gandhinagar-gujarat/r6/9999pxx79.xx79.160713215154.x8r6/catalogue/redline-network-and-computer-solutions-kalol-ng-gandhinagar-gujarat-broadband-internet-service-providers-ch0lina3e4.jpg" , text:''}
       
    ];

    useEffect(() => {
        const timer = setTimeout(() => {
            setAnimating(true);
            setTimeout(() => {
                setIndex((index + 1) % slider.length);
                setAnimating(false);
            }, 1000); // This should match the CSS animation duration
        }, 3000);

        return () => clearTimeout(timer);
    }, [index, slider.length]);

    return (
        <div className="slider-container">
            <div className={`slider-wrapper ${animating ? 'animate' : ''}`} style={{ transform: `translateX(-${index * 100}%)` }}>
                {slider.map((item, idx) => (<>
                    <img key={idx} className="slider-image" src={item.src} alt={`sliderImage-${idx}`} />
                    {
                    <div
                       className={`text-overlay`}
                     >
                       <div >
                         <h2>This is</h2> <h2 className='royal'>ROYAL</h2> <h2 className='broadband'>BROADBAND</h2>
                         <p> Broadband For All Your Need </p>
                         <span>Premium Speeds at Non-Premium Prices</span>
                       </div>
                     </div>
                     } </>
                ))}
            </div>
        </div>
    );
}

export default Imgslider;
